/**
 * Статус диалога и экскурсия wizard (E07.3–E07.4, ФТ-1.3–1.4).
 */

import { z } from "zod";
import { apiSuccessSchema } from "./envelope";

/** Уровень диалога с клиентом. */
export const dialogueStatusSchema = z.enum(["beginner", "peer", "expert"]);

export type DialogueStatus = z.infer<typeof dialogueStatusSchema>;

export const DIALOGUE_STATUS_LABELS: Record<DialogueStatus, string> = {
  beginner: "Начинающий",
  peer: "Равный диалог",
  expert: "Эксперт",
};

/** Тип медиа слайда экскурсии (`model_media.media_type`). */
export const tourMediaTypeSchema = z.enum(["image", "reference", "media_3d", "text"]);

export type TourMediaType = z.infer<typeof tourMediaTypeSchema>;

export const TOUR_MEDIA_TYPE_LABELS: Record<TourMediaType, string> = {
  image: "Изображение",
  reference: "Референс",
  media_3d: "3D-модель",
  text: "Текст",
};

/**
 * Слайд экскурсии по отрасли (ФТ-1.4).
 * `fileId` — выдача через `GET /files/{id}` (E15).
 */
export const publicTourSlideSchema = z.object({
  id: z.string().uuid(),
  mediaType: tourMediaTypeSchema,
  modelId: z.string().uuid().nullable(),
  modelName: z.string().min(1).max(255).nullable(),
  fileId: z.string().uuid(),
  title: z.string().min(1).max(512),
  sortOrder: z.number().int().min(0).max(100_000),
});

export type PublicTourSlide = z.infer<typeof publicTourSlideSchema>;

export const publicTourSlideListResponseSchema = apiSuccessSchema(z.array(publicTourSlideSchema));
